import { render, staticRenderFns } from "./AbkRecipientGroupList.vue?vue&type=template&id=5a4545f0&scoped=true&"
import script from "./AbkRecipientGroupList.vue?vue&type=script&lang=js&"
export * from "./AbkRecipientGroupList.vue?vue&type=script&lang=js&"
import style0 from "./AbkRecipientGroupList.vue?vue&type=style&index=0&id=5a4545f0&scoped=true&lang=scss&"
import style1 from "./AbkRecipientGroupList.vue?vue&type=style&index=1&id=5a4545f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a4545f0",
  null
  
)

export default component.exports